/**
 * Single dispatcher every API client wires into. Fires a custom event on
 * the window so `useAuth` can react without a circular import.
 */
export const UNAUTHORIZED_EVENT = 'teamofone:unauthorized'

export function dispatchUnauthorized(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT))
  }
}
